enum FormMethod {
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}

export default FormMethod;
